export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT =
  '/product-service/products/{{id}}';
export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_UNITS =
  '/product-service/products/{{id}}/units';
export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_UNIT_SALES_PRICES =
  '/product-service/products/{{id}}/sales/prices';
export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SALES_PROMOTIONS =
  '/product-service/products/{{id}}/sales/promotions';
export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIER_PRICES =
  '/product-service/products/{{id}}/suppliers/{{supplierId}}/prices';
export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIER_PROMOTIONS =
  '/product-service/products/{{id}}/suppliers/promotions';
export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SUPPLIERS =
  '/product-service/products/{{id}}/suppliers';
export const SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_DESCRIPTION =
  '/product-service/products/{{id}}/text';
